module.exports = {
  "redirect_uri": "https://peek.link/index.html",
  "returnTo": "https://peek.link/index.html",
  "domain": "peeklink.auth0.com",
  "clientId": "FXUrlTdFM3gH1gF5jv9RcX0Wt7SGHCLr"
}
